<template >
  <div class="openAndRenew">
    <el-breadcrumb separator-class="el-icon-arrow-right" style="padding:10px 20px;">
      <el-breadcrumb-item :to="{ path: '/admin/interfacemanage' }">接口管理</el-breadcrumb-item>
      <el-breadcrumb-item>批量开通</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="openAndRenew-content">
      <div class="content-wrap">

      <div class="title">批量开通
        <span style="color: red; font-size: 12px;">注意：按时间开通 和 按数量开通 不同时生效</span>
      </div>
      <el-form  label-width="140px" >

        <el-form-item label="开通类型"  class="is-required" prop="mobile">
          <el-radio-group v-model="type">
            <el-radio-button label="1">按时间</el-radio-button>
            <el-radio-button label="2">按数量</el-radio-button>
          </el-radio-group>
        </el-form-item>

        <div v-for="(item,index) of devloperData" :key="item.id">
          <div v-if="!(item.apiResourceDto.id == 1 && type ==2)">
            <div class="sub-title">
              <span>{{item.apiResourceDto.name}}资源</span>
              <!-- <span v-if="item.apiResourceDto.resourceType === 1">普通资源</span><span v-if="item.apiResourceDto.resourceType === 2">精品资源</span> -->
            </div>
            <el-form-item label="开通时段" v-if="type=='1'" prop="mobile" >
              <el-date-picker
                v-model="time[index]"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                :picker-options="pickerDate"
                :editable="false"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="接口调用上限" v-if="type=='2'" >
              <el-input v-model.trim="item.invoke" ></el-input>
            </el-form-item>
            <el-form-item label="去重下载上限" v-if="type=='2'" >
              <el-input v-model.trim="item.download" ></el-input>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <div class="dialog-footer tlc">
        <el-button type="primary" @click="save()" v-loading="loading">保存</el-button>
      </div>
    </div>
    </div>
  </div>
</template>
<script type="text/babel">
import devService from '@/service/devService'
export default {
  name: 'openAndRenew',
  data () {
    return {
      time: [],
      invokeLimit: [],
      downloadLimit: [],
      type: '1',
      id: this.$route.query.id,
      devloperData: [],
      loading: false,
      pickerDate: {
        disabledDate: time => {
          return time.getTime() <= Date.now() - 24 * 60 * 60 * 1000
        }
      }
    }
  },
  mounted () {
    this.fetchDevResource()
  },
  methods: {
    // 查询用户开通详情
    async fetchDevResource () {
      this.time = []
      try {
        this.devloperData = await devService.getDevelopStatistics({developerId: this.id})
        this.devloperData.forEach((item) => {
          this.time.push([])
        })
      } catch (e) {
        this.$message.error(e && e.msg)
      }
    },
    async save () {
      let form = []
      let flag = 0
      let warn = 0
      let empty = 0
      try {
        this.devloperData.forEach((item, index) => {
          // 按数量
          if (this.type == 2) {
            // 通用接口单独判断
            if (item.apiResourceDto.id == 1) {
              form.push({
                type: this.type,
                status: 2,
                startTime: '',
                endTime: '',
                userId: item.userId,
                invokeLimit: -1,
                downloadLimit: 0,
                resourceId: item.apiResourceDto.id
              })
            } else {
              if (item.invoke && item.download) {
                if (item.invoke == 0 || item.download == 0) {
                  warn = 1
                } else {
                  form.push({
                    type: this.type,
                    status: 2,
                    startTime: this.time[index][0],
                    endTime: this.time[index][1],
                    userId: item.userId,
                    invokeLimit: item.invoke || 0,
                    downloadLimit: item.download || 0,
                    resourceId: item.apiResourceDto.id
                  })
                }
                empty++
              }
            }
          } else {
            // 按时间
            // 通用接口单独判断，为空弹出错误信息
            if (item.apiResourceDto.id == 1 && this.time[index][0] == '') {
              flag = 1
            } else {
              if (this.time[index][0] != '') {
                form.push({
                  type: this.type,
                  status: 2,
                  startTime: this.time[index][0],
                  endTime: this.time[index][1],
                  userId: item.userId,
                  invokeLimit: item.invoke || 0,
                  downloadLimit: item.download || 0,
                  resourceId: item.apiResourceDto.id
                })
                empty++
              }
            }
          }
        })
        if (flag) {
          this.$message.error('通用接口时段不能为空！')
          return
        }
        if (warn) {
          this.$message.error('接口开通数必须大于0！')
          return
        }
        if (!empty) {
          this.$message.error('请至少填写一项开通数据！')
          return
        }
        await devService.batchOpenResource({list: form})
        this.$message.success('开通成功！')
        this.$router.push({name: 'interfacemanage'})
      } catch (e) {
        this.$message.error(e && e.msg)
      }
    },
    handleRemove (file, fl) {
      this.fileList2 = []
      this.devForm.businessLicenseUrl = ''
    },
    handleSuccess (response, file, fileList2) {
      this.fileList = []
      this.fileList.push(file)
      this.devForm.businessLicenseUrl = response.data
    }
  },
  watch: {
    devDialogVisible (newVal, oldVal) {
      this.title = '新增开发者'
      if (newVal && this.$refs.devForm) {
        this.devForm = {}
        this.fileList2 = []
        this.$refs.devForm.resetFields()
      }
    }
  },
  computed: {
    devDialogVisible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
<style scoped>
.openAndRenew{
  padding-top: 10px;
}
.openAndRenew .openAndRenew-content{
  background-color: white;
  padding: 20px;
}
.openAndRenew .openAndRenew-content .content-wrap{
  width: 460px;
  margin-left: 20%;
  /* margin: 0 auto; */
}
.openAndRenew .openAndRenew-content .title{
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin-bottom: 30px;
  text-align: center;
}
.openAndRenew .openAndRenew-content .sub-title{
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-bottom: 16px;
}
</style>
<style type="text/css">
.openAndRenew .el-form-item{
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/admin/add-developer/openAndRenew.vue